import { render } from "./OverlayLogin.vue?vue&type=template&id=3c4385c7"
import script from "./OverlayLogin.vue?vue&type=script&lang=js"
export * from "./OverlayLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__